export const MY_COMPENSATORY_TIME = '/my_compensatory_time';
export const MY_COMPENSATORY_TIME_BY_ID = id =>
  `/my_compensatory_time/${id}/manage`;
